var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.796,
    height: 7.465,
    viewBox: "0 0 12.796 7.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-preview-2433790",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162433",
    "data-name": "Group 162433",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15246",
    "data-name": "Path 15246",
    d: "M6.4,12.465C2.947,12.465.235,9.212.121,9.07a.533.533,0,0,1,0-.676C.235,8.255,2.947,5,6.4,5s6.164,3.255,6.277,3.394a.533.533,0,0,1,0,.676C12.562,9.212,9.85,12.465,6.4,12.465ZM1.253,8.732c.754.785,2.806,3.732,5.146,3.732s4.393-2.946,5.146-3.732C10.79,7.947,8.739,6.066,6.4,6.066S2.005,7.946,1.253,8.732Z",
    transform: "translate(0 -5)",
    fill: "#008d9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15247",
    "data-name": "Path 15247",
    d: "M10.133,12.265a2.133,2.133,0,1,1,2.133-2.133A2.133,2.133,0,0,1,10.133,12.265Zm0-3.2A1.066,1.066,0,1,0,11.2,10.133,1.066,1.066,0,0,0,10.133,9.066Z",
    transform: "translate(-3.735 -6.4)",
    fill: "#008d9c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.b3ce166f6ebf5f0f366b8382ea0b35a2.svg";
export { ForwardRef as ReactComponent };